export const formatMongoDoc = (data: any) => {
  if (!data) return data;

  const { _id, ...rest } = data;

  return {
    ...rest,
    id: _id,
  };
};

export const mapMongoDocs = (data: any[]) => {
  if (!Array.isArray(data)) return [];
  return data.map(formatMongoDoc);
};